import React from 'react';
import styled, { keyframes } from 'styled-components';

const waveAnimation = keyframes`
  0% {
    height: 8px;
  }
  20% {
    height: 16px;
  }
  40% {
    height: 12px;
  }
  60% {
    height: 20px;
  }
  80% {
    height: 10px;
  }
  100% {
    height: 8px;
  }
`;

const WaveformContainer = styled.div`
  position: absolute;
  top: 25%;
  right: 15%;
  transform: translateY(-50%);
  display: ${props => props.isActive ? 'flex' : 'none'};
  align-items: center;
  gap: 2px;
  padding: 4px;
  border-radius: 4px;
  z-index: 10;
`;

const WaveBar = styled.div`
  width: 2px;
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 2px;
  animation: ${waveAnimation} 0.8s ease-in-out infinite;
  animation-delay: ${props => props.delay}s;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.3);
`;

const VoiceWaveform = ({ isActive }) => {
  return (
    <WaveformContainer isActive={isActive}>
      <WaveBar delay="0" />
      <WaveBar delay="0.1" />
      <WaveBar delay="0.2" />
      <WaveBar delay="0.3" />
      <WaveBar delay="0.4" />
    </WaveformContainer>
  );
};

export default VoiceWaveform; 